import { render } from "./add-stock-modal.vue?vue&type=template&id=0456244b"
import script from "./add-stock-modal.vue?vue&type=script&lang=js"
export * from "./add-stock-modal.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./add-stock-modal.vue?vue&type=style&index=1&id=0456244b&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__